import { ObservableValue } from '@mp/core';
import { SceneComponent } from '../SceneComponent';

type NodeDesc = {
  target: ObservableValue<SceneComponent|null>;
  targetProperty: ObservableValue<string|null>;
  source: ObservableValue<SceneComponent|null>;
  sourceProperty: ObservableValue<string|null>;
  bound: boolean;
}

const defaultInputs: Inputs = {
  name: 'default',
  target: null,
  targetProperty: '',
  source: null,
  sourceProperty: '',
}

type Inputs = {
  name: string;
  target: SceneComponent|null;
  targetProperty: string;
  source: SceneComponent|null;
  sourceProperty: string;
}

class NodeBinder extends SceneComponent {
  static nodeMapping: Map<string, NodeDesc> = new Map();

  inputs: Inputs = {
    ...defaultInputs,
  }
  constructor() {
    super();

    this.onChanged = this.onChanged.bind(this);
  }

  onInit() {
    let nodeDesc: NodeDesc;
    if (NodeBinder.nodeMapping.has(this.inputs.name)) {
      nodeDesc = NodeBinder.nodeMapping.get(this.inputs.name);
    }
    else {
      nodeDesc = {
        target: new ObservableValue(null),
        targetProperty: new ObservableValue(null),
        source: new ObservableValue(null),
        sourceProperty: new ObservableValue(null),
        bound: false,
      };

      NodeBinder.nodeMapping.set(this.inputs.name, nodeDesc);
    }

    if (this.inputs.source) {
      nodeDesc.source.value = this.inputs.source;
    }

    if (this.inputs.target) {
      nodeDesc.target.value = this.inputs.target;
    }

    if (this.inputs.sourceProperty) {
      nodeDesc.sourceProperty.value = this.inputs.sourceProperty;
    }

    if (this.inputs.targetProperty) {
      nodeDesc.targetProperty.value = this.inputs.targetProperty;
    }

    nodeDesc.source.onChanged(this.onChanged);
    nodeDesc.sourceProperty.onChanged(this.onChanged);
    nodeDesc.target.onChanged(this.onChanged);
    nodeDesc.targetProperty.onChanged(this.onChanged);
  }

  onChanged() {
    const nodeDesc = NodeBinder.nodeMapping.get(this.inputs.name);

    const source = nodeDesc.source.value;
    const sourceProperty = nodeDesc.sourceProperty.value;
    const target = nodeDesc.target.value;
    const targetProperty = nodeDesc.targetProperty.value;

    if (!nodeDesc.bound && source && sourceProperty && target && targetProperty) {
      target.bind(targetProperty, source, sourceProperty);
      nodeDesc.bound = true;
    }
  }
}

export const nodeBinderType = 'mp.nodeBinder';
export const makeNodeBinder = function() {
  return new NodeBinder();
}
